import './components.css';
const VrijSoliciteren = () => {
    return (
        <div className="card">
            <h5 className="card-header">Gezocht</h5>
            <div className="card-body">
                <a href="https://www.zorgnetwerktrento.be/sollicitatieformulier" target="_top" className="btn btn-primary right-btn">
                    Solliciteer
                </a>
                <a href="https://www.zorgnetwerktrento.be/sollicitatieformulier" className="jobs" target="_top">
                    <h5 className="card-title">Vrij solliciteren</h5>
                </a>
                <p className="card-text">Klik hier om vrij te solliciteren.</p>
            </div>
        </div>
    );
};
export default VrijSoliciteren;

const Job1 = () => {
    return (
        <div className="card">
            <div className="card-body">
                <a className="btn btn-primary right-btn" href="https://www.zorgnetwerktrento.be/vacature-personeelsdienst-specialisatie-payroll-0" target="_top">
                    Bekijken
                </a>
                <a className="jobs" href="https://www.zorgnetwerktrento.be/vacature-personeelsdienst-specialisatie-payroll-0" target="_top">
                    <h5 className="card-title">Vacature Personeelsdienst</h5>
                </a>
                <p className="card-text">Medewerker Personeelsdienst - specialisatie payroll.</p>
            </div>
        </div>
    );
};

const Job2 = () => {
    return (
        <div className="card">
            <div className="card-body">
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet-voltijdsdeeltijds" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet-voltijdsdeeltijds" target="_top" className="jobs">
                    <h5 className="card-title">Vacature Verpleegkundige</h5>
                </a>
                <p className="card-text">Verpleegkundige Campus De vliet te zele. </p>
            </div>
        </div>
    );
};

const Job3 = () => {
    return (
        <div className="card">
            <div className="card-body">
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet" className="jobs">
                    <h5 className="card-title">Vacature Verpleegkundige</h5>
                </a>
                <p className="card-text">Verpleegkundige Campus Sint-Jozef te Moerzeke.</p>
            </div>
        </div>
    );
};

const Job4 = () => {
    return (
        <div className="card">
            <div className="card-body">
                <a href="https://www.zorgnetwerktrento.be/vacature-zorgkundige" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-zorgkundige" className="jobs">
                    <h5 className="card-title">Vacature zorgkundige</h5>
                </a>

                <p className="card-text">Zorgkundige campus De Vliet. Contract bepaalde duur voor 6 maanden met zicht op contract onbepaalde duur. </p>
            </div>
        </div>
    );
};

const Job5 = () => {
    return (
        <div className="p-4 md:w-1/3 sm:mb-0 mb-6">
            <div className="rounded-lg h-64 overflow-hidden">
                <img alt="content" className="object-cover object-center h-full w-full" src="https://dummyimage.com/1205x505" />
            </div>
            <h2 className="text-xl font-medium title-font text-gray-900 mt-5">The 400 Blows</h2>
            <p className="text-base leading-relaxed mt-2">Swag shoivdigoitch literally meditation subway tile tumblr cold-pressed. Gastropub street art beard dreamcatcher neutra, ethical XOXO lumbersexual.</p>
            <a href="https://test.com" className="text-indigo-500 inline-flex items-center mt-3">
                Learn More
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
            </a>
        </div>
    );
};

const NewJob = () => {
    return (
        <div className="body">
            <a href="https://www.zorgnetwerktrento.be/jobs" target="_top">
                <div className="card h-100" style={{ width: `18rem` }}>
                    <img src="./img/vacature-Zorg-Sj-Okt-2021.png" alt="New Job" className="card-img-top post-img" />
                    <div className="card-body">
                        <div className="card-text">
                            <span className="red_text"></span>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

const Jobs = () => {
    return (
        <div className="card">
            <div className="card-body border-bottom">
                <a className="btn btn-primary right-btn" href="https://www.zorgnetwerktrento.be/vacature-zorgkundige-wzc-sint-jozef" target="_top">
                    Bekijken
                </a>
                <a className="jobs" href="https://www.zorgnetwerktrento.be/vacature-zorgkundige-wzc-sint-jozef" target="_top">
                    <h5 className="card-title">
                        <span className="red_text"> New! </span> Vacature Zorgkundige
                    </h5>
                </a>
                <p className="card-text">Zorgkundige te WZC Sint-Jozef. - Onbepaalde duur.</p>
            </div>
            <div className="card-body border-bottom">
                <a className="btn btn-primary right-btn" href="https://www.zorgnetwerktrento.be/vacature-personeelsdienst-specialisatie-payroll-0" target="_top">
                    Bekijken
                </a>
                <a className="jobs" href="https://www.zorgnetwerktrento.be/vacature-personeelsdienst-specialisatie-payroll-0" target="_top">
                    <h5 className="card-title">Vacature Personeelsdienst</h5>
                </a>
                <p className="card-text">Medewerker Personeelsdienst - specialisatie payroll.</p>
            </div>
            <div className="card-body border-bottom">
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet-voltijdsdeeltijds" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet-voltijdsdeeltijds" target="_top" className="jobs">
                    <h5 className="card-title">Vacature Verpleegkundige</h5>
                </a>
                <p className="card-text">Verpleegkundige Campus De vliet te zele. </p>
            </div>
            <div className="card-body border-bottom">
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-verpleegkundige-campus-de-vliet" className="jobs">
                    <h5 className="card-title">Vacature Verpleegkundige</h5>
                </a>
                <p className="card-text">Verpleegkundige Campus Sint-Jozef te Moerzeke.</p>
            </div>
            <div className="card-body border-bottom">
                <a href="https://www.zorgnetwerktrento.be/vacature-zorgkundige" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-zorgkundige" className="jobs">
                    <h5 className="card-title">Vacature zorgkundige</h5>
                </a>

                <p className="card-text">Zorgkundige campus De Vliet. Contract bepaalde duur voor 6 maanden met zicht op contract onbepaalde duur. </p>
            </div>
            <div className="card-body border-bottom">
                <a href="https://www.zorgnetwerktrento.be/vacature-woonzorgmedewerker-campus-de-vliet-23uweek" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-woonzorgmedewerker-campus-de-vliet-23uweek" className="jobs">
                    <h5 className="card-title">Vacature Woonzorgmedewerker 23u/week</h5>
                </a>

                <p className="card-text">Woonzorgmedewerker campus De Vliet 23u/week. </p>
            </div>
            <div className="card-body">
                <a href="https://www.zorgnetwerktrento.be/vacature-woonzorgmedewerker-campus-sint-jozef-moerzeke-19uweek" target="_top" className="btn btn-primary right-btn">
                    Bekijken
                </a>
                <a href="https://www.zorgnetwerktrento.be/vacature-woonzorgmedewerker-campus-sint-jozef-moerzeke-19uweek" className="jobs">
                    <h5 className="card-title">Vacature Woonzorgmedewerker 19u/week</h5>
                </a>
                <p className="card-text">Woonzorgmedewerker campus Sint-Jozef - 19u/week - bepaalde duur. </p>
            </div>
        </div>
    );
};

export { Job1, Job2, Job3, Job4, Job5, NewJob, Jobs };
